import {getSessionProfile} from "./SessionService";

export const roleToScope = (role) => {
    const data = {
        'super_admin': 'super_admin',
        'administrator': 'administrators',
        'teacher': 'teachers',
        'parent': 'parents',
    }

    return data[role] || role;
}

export default {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'administrator',
    TEACHER: 'teacher',
    PARENT: 'parent',
}

export const inviteRoles = [
    'administrator',
    'teacher',
];

export const hasAnyRole = (rolesToCheck, userRoles) => {
    if (!userRoles) return false;

    const lowerCaseRolesToCheck = rolesToCheck.map(role => role.toLowerCase());
    return userRoles.some(userRole => lowerCaseRolesToCheck.includes(userRole.name.toLowerCase()));
};

export const hasRole = (roleToCheck, userRoles) => {
    if (!userRoles) return false;

    return userRoles.some(userRole => userRole === roleToCheck.toLowerCase());
}
export const hasExactRoleOnly = (roleToCheck, userRoles) => {
    if (!userRoles) return false;

    return userRoles.length === 1 && userRoles[0] === roleToCheck.toLowerCase();
}

export const isSuperAdmin = (userRoles) => hasRole('super_admin', userRoles);
export const isAdmin = (userRoles) => hasRole('administrator', userRoles);
export const isTeacher = (userRoles) => hasRole('teacher', userRoles);
export const isParent = (userRoles) => hasRole('parent', userRoles);

const getCurrentUserRoles = async () => {
    const user = await getSessionProfile();

    return user.roles?.map(role => role.name?.toLowerCase()) ?? [];
};

export const currentUserHasRole = async (role) => {
    const roles = await getCurrentUserRoles();
    return hasRole(role, roles);
}

export const isCurrentUserSuperAdmin =  async () => {
    const roles = await getCurrentUserRoles();
    return isSuperAdmin(roles);
}
export const isCurrentUserAdmin =  async () => {
    const roles = await getCurrentUserRoles();
    return isAdmin(roles);
}
export const isCurrentUserTeacher =  async () => {
    const roles = await getCurrentUserRoles();

    return isTeacher(roles);
}
export const isCurrentUserParent =  async () => {
    const roles = await getCurrentUserRoles();
    return isParent(roles);
}
